import { useState } from "react";
import About from "./About";
import Gallery from "./Gallery";
import Products from "./Products";

const Main = () => {
  const [menuIndex, setMenuIndex] = useState(0);
  const name = "남양주";
  const phoneNumber = "01037655677";
  const phoneNumHyphen = "010-3765-5677";
  return (
    <div className="web-form">
      <div className="web-title">
        <span>{name}생수</span>
      </div>
      <div className="main-menu" style={{ display: "flex" }}>
        <div
          style={{ flex: "1" }}
          onClick={() => {
            setMenuIndex(0);
          }}
        >
          회사소개
        </div>
        <div
          style={{ flex: "1" }}
          onClick={() => {
            setMenuIndex(1);
          }}
        >
          제품소개
        </div>
        <div
          style={{ flex: "1" }}
          onClick={() => {
            setMenuIndex(2);
          }}
        >
          갤러리
        </div>
      </div>
      <div
        className="connect-phone"
        onClick={() => {
          document.location.href = "tel:" + phoneNumber;
        }}
      >
        <span>📞 전화문의 &nbsp; | &nbsp; {phoneNumHyphen}</span>
      </div>
      <div className="contents">
        {menuIndex === 0 ? (
          <>
            <About name={name}></About>
          </>
        ) : menuIndex === 1 ? (
          <>
            <Products></Products>
          </>
        ) : (
          <Gallery></Gallery>
        )}
      </div>
      <div className="footer">
        <div className="center-greetings">
          <h2>Center Greetings</h2>
          <hr></hr>
          <div className="center-greetings-msg">
            <span>
              자세한 상담을 원하시는 경우 연락주시면 친절히 상담해 드리겠습니다.
            </span>
          </div>
          <div
            style={{ marginTop: "25px" }}
            className="connect-phone"
            onClick={() => {
              document.location.href = "tel:" + phoneNumber;
            }}
          >
            <span>📞 전화연결 | {phoneNumHyphen}</span>
          </div>
          <div
            className="connect-msg"
            onClick={() => {
              document.location.href = "sms:" + { phoneNumber };
            }}
          >
            <span>✉️ 문자문의 | {phoneNumHyphen}</span>
          </div>
        </div>

        <div className="strip">
          <span>
            {name}생수|대표번호 : {phoneNumHyphen}
          </span>
          <br></br>
          <span>Copyright (c) 2022. {name}생수. Al right Reserved.</span>
        </div>
      </div>
    </div>
  );
};

export default Main;
